import { Link as OrigLink } from 'gatsby'
import styled from 'styled-components'
import { NOBEL_GRAY, PAGAMO_RED } from 'constants/colors'
import OrigArrow from './Icons/Arrow'

export const Link = styled(props => <OrigLink {...props} />)`
  color: ${NOBEL_GRAY};
  font-size: 0.9rem;
`

export const Container = styled.nav`
  margin: 0 auto;
  max-width: 1080px;
  padding: 0 1rem;
  height: 43px;
  display: flex;
  align-items: center;

  * {
    padding-right: 5px;
  }

  ${Link}:last-child {
    color: ${PAGAMO_RED};
  }
`

export const Arrow = OrigArrow
